(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?(console.warn(p+" only loads once. Ignoring:",g),d[l](...r)):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({ key: "AIzaSyDECsFp5EH03WXUuyuQpOvkNhWuBZCcmU8", v: "weekly"});

// Approximate bounding box for the UAE
const UAE_BOUNDS = {
    north: 26.08,
    south: 22.63,
    west: 51.58,
    east: 56.38,
};

// --- GLOBAL VARIABLES ---
// Declared here so they are accessible in all functions (like selectPlace)
let map, marker, autocompleteService, sessionToken, typingTimer, activeStoreMarker;
const doneTypingInterval = 500;

async function initAddressMap() {
    try {
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
        const { Place } = await google.maps.importLibrary("places");
        const { Geocoder } = await google.maps.importLibrary("geocoding");
        const { AutocompleteService, AutocompleteSessionToken } = await google.maps.importLibrary("places");

        // Your default fallback position (Dubai)
        const position = { lat: 25.197673, lng: 55.276295 };
        const geocoder = new Geocoder();

        // 1. Setup the Map Instance (Assigned to global 'map')
        map = new Map(document.getElementById("map"), {
            zoom: 14,
            center: position,
            mapId: "map", 
            restriction: {
                latLngBounds: UAE_BOUNDS,
                strictBounds: false,
            },
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: true,
        });

        // 2. Define the Marker (Assigned to global 'marker')
        marker = new AdvancedMarkerElement({
            map: map,
            position: position,
            title: "Pin Your Location",
            gmpDraggable: true,
        });

        // 3. Attempt Geolocation
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (browserPos) => {
                    const userPos = {
                        lat: browserPos.coords.latitude,
                        lng: browserPos.coords.longitude
                    };
                    map.setCenter(userPos);
                    marker.position = userPos;
                },
                () => {
                    console.warn("Location access denied or timed out. Using default.");
                },
                { timeout: 5000 }
            );
        }

        // Initialize Autocomplete Services
        autocompleteService = new AutocompleteService();
        sessionToken = new AutocompleteSessionToken();

        // --- EVENT LISTENERS ---

        // Drag End Event
        marker.addListener("dragend", async () => {
            const newPos = marker.position;
            updateAddressFromCoords(newPos, geocoder);
            updateHiddenLatLngFields(newPos);
            $('.js-select-lat-long').removeClass('disabled');
        });

        // Searchbar Logic
        const $searchBar = $('#map_searchbar');
        const $suggestionsList = $('#address-suggestions');

        $searchBar.on('input', function() {
            clearTimeout(typingTimer);
            const query = $(this).val();

            if (query.length === 0) {
                $('#search-loader').hide();
                $suggestionsList.empty().hide();
                return;
            }

            if (query.length > 3) {
                $('#search-loader').show();
                typingTimer = setTimeout(() => {
                    getSuggestions(query);
                }, doneTypingInterval);
            }
        });

        // Close suggestions when clicking outside
        $(document).on('click', (e) => {
            if (!$(e.target).closest('.search-container').length) $suggestionsList.hide();
        });

    } catch (error) {
        console.error("Error loading Google Maps:", error);
    }
}

/**
 * Fetches suggestions from Google restricted to UAE
 */
function getSuggestions(query) {
    const request = {
        input: query,
        sessionToken: sessionToken,
        componentRestrictions: { country: "ae" },
        locationRestriction: UAE_BOUNDS
    };

    autocompleteService.getPlacePredictions(request, (predictions, status) => {
        $('#search-loader').hide();
        if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) return;
        displaySuggestions(predictions);
    });
}

/**
 * Renders the dropdown UI
 */
function displaySuggestions(predictions) {
    const $list = $('#address-suggestions');
    $list.empty().show();

    predictions.forEach(prediction => {
        const $li = $(`<li class="suggestion-item">${prediction.description}</li>`);
        $li.on('click', () => {
            $('#map_searchbar').val(prediction.description);
            $list.hide();
            selectPlace(prediction.place_id);
            sessionToken = new google.maps.places.AutocompleteSessionToken();
        });
        $list.append($li);
    });
}

/**
 * Fetches coordinates for the selected suggestion and moves the map
 */
async function selectPlace(placeId) {
    $('#search-loader').show();

    try {
        const { Place } = await google.maps.importLibrary("places");
        const place = new Place({ id: placeId });
        await place.fetchFields({ fields: ["location", "displayName"] });

        $('#search-loader').hide();

        if (place.location && map && marker) {
            // Move Map
            map.setCenter(place.location);
            map.setZoom(17);

            // Move Marker
            marker.position = place.location;
            updateHiddenLatLngFields(place.location);
            
            $('.js-select-lat-long').removeClass('disabled');            
            $('.js-remove-selected-address').addClass('show');
        }
    } catch (e) {
        console.error("Select place failed:", e);
        $('#search-loader').hide();
    }
}

/**
 * Translates Coordinates into a Text Address
 */
function updateAddressFromCoords(coords, geocoder) {
    geocoder.geocode({ location: coords, region: 'AE' }, (results, status) => {
        if (status === "OK" && results[0]) {
            const isUAE = results[0].address_components.some(component => 
                component.short_name === 'AE'
            );

            if (isUAE) {
                $('#map_searchbar').val(results[0].formatted_address);
                $('.add_pin span').text(` Pinned: ${results[0].formatted_address}`);
            } else {
                // Use alert if showToast isn't defined globally
                if(typeof showToast === "function") {
                    showToast(`<h4 class="red">We only deliver within UAE.</h4><p>Please select a valid location.</p>`);
                } else {
                    alert("We only deliver within UAE.");
                }
                $('.js-select-lat-long').addClass('disabled');
            }
        }
    });
}

/**
 * Renders a single active marker on the Store Finder Map.
 * Finds the first store with valid coordinates for the initial pin.
 */
 async function initStoreFinderMap(stores = []) {
    try {
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        // 1. Initialize Map instance if it doesn't exist
        if (!map) {
            map = new Map(document.querySelector(".render_map"), {
                zoom: 11,
                center: { lat: 25.197673, lng: 55.276295 }, // Default Dubai
                mapId: "store_finder_map",
                mapTypeControl: false,
                streetViewControl: false,
            });
        }

        // 2. If data is provided, find the first valid store to pin
        if (stores.length > 0) {
            const firstValidIndex = stores.findIndex(s => 
                s.address.latitude && s.address.longitude && 
                parseFloat(s.address.latitude) !== 0 && 
                parseFloat(s.address.longitude) !== 0
            );

            if (firstValidIndex !== -1) {
                const firstStore = stores[firstValidIndex];
                const firstStorePos = { 
                    lat: parseFloat(firstStore.address.latitude), 
                    lng: parseFloat(firstStore.address.longitude) 
                };

                // Remove old marker if exists and create new one
                updateActiveMarker(firstStorePos, firstStore.name, AdvancedMarkerElement);
                
                // UI Sync: Highlight the correct item in the list
                $('.adil_store').removeClass('pin-active');
                $('.adil_store').eq(firstValidIndex).addClass('pin-active');
                
                map.setCenter(firstStorePos);
                map.setZoom(16);
            }
        }
    } catch (error) {
        console.error("Error initializing Store Finder Map:", error);
    }
}

/**
 * Helper to manage the single global activeStoreMarker
 */
function updateActiveMarker(position, title, MarkerClass) {
    if (activeStoreMarker) {
        activeStoreMarker.map = null; // Correct way to remove AdvancedMarkerElement
    }
    activeStoreMarker = new MarkerClass({
        map: map,
        position: position,
        title: title,
    });
}



/**
 * Updates latitude and longitude hidden inputs
 */
function updateHiddenLatLngFields(coords) {
    const lat = typeof coords.lat === 'function' ? coords.lat() : coords.lat;
    const lng = typeof coords.lng === 'function' ? coords.lng() : coords.lng;

    if ($('#id_latitude').length > 0) $('#id_latitude').val(lat);
    if ($('#id_longitude').length > 0) $('#id_longitude').val(lng);
}

// --- DOCUMENT READY / INITIALIZATION ---

$(document).on('click', '.js-open-address-map', function(e){
    e.preventDefault();
    $('.address_map_popup').addClass('open');
    $('body').addClass('locked');
    // Trigger a resize to ensure map renders correctly if it was hidden
    if (map) {
        google.maps.event.trigger(map, "resize");

        // 3. Check if we should use existing pinned coordinates
        if ($(this).attr('data-pinned') === "true" || $(this).data('pinned') === true) {
            const savedLat = parseFloat($('#id_latitude').val());
            const savedLng = parseFloat($('#id_longitude').val());

            // Check if values are valid numbers (not empty or NaN)
            if (!isNaN(savedLat) && !isNaN(savedLng)) {
                console.log(savedLat, savedLng)
                const savedPos = { lat: savedLat, lng: savedLng };
                
                // Update map and marker
                map.setCenter(savedPos);
                marker.position = savedPos;
                
                // Optional: Zoom in closer if it's a specific saved address
                map.setZoom(17); 
            }
        }
    }
}).on('click', '.js-close-address-map', function(e){
    e.preventDefault();
    $('.address_map_popup').removeClass('open');
    $('body').removeClass('locked');
}).on('click', '.js-remove-selected-address', function(e){
    e.preventDefault();
    $('#map_searchbar').val('');
    $(this).removeClass('show');
});

$(document).on('click', '.js-select-lat-long', function(e){
    e.preventDefault();
    if ($(this).hasClass('disabled')) return;
    
    $('.address_map_popup').removeClass('open');
    $('body').removeClass('locked');
    const $pinned = $('#map_searchbar').val();
    $('.add_pin span').text(` Pinned: ${$pinned}`);
    $('#id_reverse_geocode').val($pinned);
});

$(document).ready(function() {
    if ($('#map').length > 0) {
        initAddressMap();
    }   

    const store_finder = $('.store_finder.js-fetch-stores');
    if (store_finder.length > 0) {
        const store_list = store_finder.find('.store_list');
        const store_map = store_finder.find('.store_map');

        // Sync height: Assign map height to store_list max-height
        const syncHeight = () => {
            if ($(window).width() > 720) {
                const mapHeight = store_map.outerHeight();
                store_list.css({'max-height': mapHeight + 'px', 'height': mapHeight + 'px'});
            }else {
                // Reset height for mobile/tablet layouts
                $('.store_list').css({
                    'max-height': 'inherit', 
                    'height': '60dvh'
                });
            }
        };
        syncHeight();

        $.ajax({
            url: '/api/stores/',
            type: 'GET',
            dataType: 'json',
            success: function(data) {
                store_list.empty();

                data.forEach(function(store) {
                    // 1. Construct Address
                    const addr = store.address;
                    const fullAddress = `${addr.line1} ${addr.line2 || ''} ${addr.line3 || ''}, ${addr.line4.display_name}`.replace(/\s+/g, ' ').trim();

                    // 2. Determine Current Timing
                    const now = new Date();
                    // JS getDay() is 0 (Sun) - 6 (Sat). API Weekday is 1 (Mon) - 7 (Sun).
                    const jsDay = now.getDay();
                    const apiDay = jsDay === 0 ? 7 : jsDay;
                    
                    const todayTiming = store.opening_periods.find(p => p.weekday === apiDay);
                    
                    let isOpen = false;
                    let displayTime = "";
                    let statusClass = "closed";
                    let statusLabel = "Closed";

                    if (todayTiming) {
                        const currentTimeStr = now.toTimeString().split(' ')[0]; // "HH:MM:SS"
                        isOpen = (currentTimeStr >= todayTiming.start && currentTimeStr < todayTiming.end);
                        
                        statusClass = isOpen ? 'open' : 'closed';
                        statusLabel = isOpen ? 'Open' : 'Closed';

                        // Format "23:00:00" to "11:00 PM" for display
                        const formatTime = (timeStr) => {
                            const [h, m] = timeStr.split(':');
                            const hour = parseInt(h);
                            const ampm = hour >= 12 ? 'PM' : 'AM';
                            const displayHour = hour % 12 || 12;
                            return `${displayHour}:${m} ${ampm}`;
                        };

                        displayTime = isOpen 
                            ? `Closes ${formatTime(todayTiming.end)}` 
                            : `Opens ${formatTime(todayTiming.start)}`;
                    }

                    // Extract coordinates from the nested address object
                    const lat = store.address.latitude || 0;
                    const lng = store.address.longitude || 0;

                    // Construct the Directions URL using coordinates
                    const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;

                    // 3. Render HTML
                    const storeHtml = `
                        <div class="adil_store" data-latitude="${lat}" data-longitude="${lng}">
                            <h3 class="store-name">${store.name}</h3>
                            <p class="store-address">${fullAddress}</p>
                            <div class="store-timing">
                                <span class="${statusClass}">${statusLabel}</span>
                                <span>${displayTime}</span>
                            </div>
                            ${lat !==0 && lng !==0 ? `
                                <div class="store-actions">
                                    <a href="${directionsUrl}" target="_blank" class="get-directions">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22" viewBox="0 0 16 22">
                                            <g id="google-maps-svgrepo-com" transform="translate(-8 -5)">
                                                <path id="Path_2" data-name="Path 2" d="M24,12.812v.043c0,.018,0,.036,0,.054s0,.042,0,.063c0,3.336-2.6,6.289-4.339,8.266-.5.573-.937,1.065-1.212,1.459A11.445,11.445,0,0,0,16.816,26.2a.817.817,0,0,1-1.633,0A11.445,11.445,0,0,0,13.551,22.7c-.275-.394-.708-.886-1.212-1.459C10.6,19.26,8,16.307,8,12.971q0-.032,0-.063,0-.048,0-.1A7.907,7.907,0,0,1,16,5,7.907,7.907,0,0,1,24,12.812Zm-8,2.87a3.03,3.03,0,1,0-3.1-3.029A3.066,3.066,0,0,0,16,15.681Z" fill="#34a851" fill-rule="evenodd"/>
                                                <path id="Path_3" data-name="Path 3" d="M23.105,9.219A7.978,7.978,0,0,0,18.35,5.343l-4.595,5.219A3.129,3.129,0,0,1,16,9.623a3.066,3.066,0,0,1,3.1,3.029,2.97,2.97,0,0,1-.621,1.819Z" fill="#4285f5"/>
                                                <path id="Path_4" data-name="Path 4" d="M12.431,21.343l-.093-.105a21.368,21.368,0,0,1-3.57-5.011L13.544,10.8a2.97,2.97,0,0,0-.646,1.851A3.066,3.066,0,0,0,16,15.682a3.13,3.13,0,0,0,2.215-.909Z" fill="#f9bb0e"/>
                                                <path id="Path_5" data-name="Path 5" d="M9.893,7.766A7.673,7.673,0,0,0,8,12.812q0,.048,0,.1,0,.031,0,.063a7.85,7.85,0,0,0,.769,3.254l4.767-5.415Z" fill="#e74335"/>
                                                <path id="Path_6" data-name="Path 6" d="M18.35,5.343A8.177,8.177,0,0,0,16,5,8.062,8.062,0,0,0,9.893,7.766l3.643,3.045.008-.009a3.074,3.074,0,0,1,.212-.24Z" fill="#1a73e6"/>
                                            </g>
                                        </svg>                                    
                                        <span>Get Directions on Google Maps</spa>
                                    </a>
                                </div>` 
                            : ''}                            
                        </div>`;

                    store_list.append(storeHtml);
                });

                // Call the fixed function with the data
                initStoreFinderMap(data); 
                syncHeight();
            },
            error: function(xhr) {
                console.error('Failed to fetch stores:', xhr.statusText);
            }
        });

        // Update height on window resize
        $(window).on('resize', syncHeight);
    }

    // 3. Click Event for Store Selection
    $(document).on('click', '.adil_store', async function() {
        const $this = $(this);
        const lat = parseFloat($this.data('latitude'));
        const lng = parseFloat($this.data('longitude'));
        const name = $this.find('.store-name').text();
    
        // Prevent pinning if coordinates are missing or zero
        if (lat && lng && lat !== 0 && lng !== 0) {
            $('.adil_store').removeClass('pin-active');
            $this.addClass('pin-active');
    
            const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
            const newPos = { lat, lng };
            
            updateActiveMarker(newPos, name, AdvancedMarkerElement);
            map.panTo(newPos);
            map.setZoom(15);
        }else{
            showToast(`<h4 class="red">Error</h4><p>Store location missing!</p>`);
        }
    });

    $(document).on('input', '#store_search', function() {
        const query = $(this).val().toLowerCase().trim();
        const $stores = $('.adil_store');
    
        $stores.each(function() {
            const $store = $(this);
            // Get the text from the name and address fields
            const storeName = $store.find('.store-name').text().toLowerCase();
            const storeAddress = $store.find('.store-address').text().toLowerCase();
    
            // Check if query exists in either string
            if (storeName.includes(query) || storeAddress.includes(query)) {
                $store.show();
            } else {
                $store.hide();
            }
        });
    
        // Optional: Show a message if no stores match
        const visibleCount = $stores.filter(':visible').length;
        if (visibleCount === 0) {
            if ($('.no-results').length === 0) {
                $('.store_list').append(`<p class="no-results">Adil isn't in your area today, but we’re coming for your kitchen soon!</p>`);
            }
        } else {
            $('.no-results').remove();
        }
    });
});